export default "__VITE_ASSET__Cro25w_k__"